import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import {
  Button, Icon, Label, Text, View,
} from '@vectord/ui';

import ConnectWithAlumniButton from '@alumni_v2/ui/ConnectWithAlumniButton';
import { useMediaQuery } from '@common/hooks';

import ACS_BANNER_BG from '@alumni_v2/images/webp/acs-banner-bg.webp';
import IMG_1000 from '@alumni_v2/images/svg/Img_1000.svg';

import {
  AVATAR_IMG_URL,
  ALL_AVATARS_IMG,
  acsBannerStripData,
  acsBannerStripDataV2,
} from './constant';

import styles from './AlumniConnectBoxRevamp.module.scss';

const AlumniConnectBoxRevamp = ({
  name, setSidebarModalStage, onModalClose, userId, isModalOpen,
}) => {
  const [stripStep, setSripStep] = useState(0);
  const { tablet: isTablet } = useMediaQuery();
  const { showExpertAcs } = window.__INITIAL_STATE__;

  useEffect(() => {
    let intervalId;

    if (isModalOpen) {
      intervalId = setInterval(() => {
        setSripStep((prev) => {
          if (prev === acsBannerStripData.length - 1) {
            return 0;
          }

          return prev + 1;
        });
      }, 6000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isModalOpen]);

  return (
    showExpertAcs ? (
      <View className="
        vd-border-l-[1px] vd-border-solid vd-border-border-neutral-subtler
        vd-border-r-[1px] vd-border-solid vd-border-border-neutral-subtler
        vd-border-t-[1px] vd-border-solid vd-border-border-neutral-subtler
        vd-relative vd-flex-col"
      >
        <img
          src={ACS_BANNER_BG}
          alt="banner-bg"
          className="vd-absolute"
          style={{ zIndex: '-1' }}
        />
        <View className="vd-absolute vd-right-none">
          <Label
            label="NEW"
            labelSize="xxs"
            labelVariant="brand"
          />
        </View>
        <View className="vd-flex-col vd-p-16 vd-gap-16">
          <View className="vd-flex-col vd-gap-12">
            <View className="vd-flex-col vd-gap-8">
              <Text
                fontSize="b1"
                weight="semibold"
                color="text-neutral-primary"
              >
                Connect for a Free 1:1 with Expert
              </Text>
              <Text
                color="text-neutral-tertiary"
                fontSize="b3"
                weight="normal"
                className="vd-tracking-[0.012rem]"
              >
                We will match you with the expert based on their
                <br />
                availability and your career preferences
              </Text>
            </View>
            <View className="vd-flex vd-gap-12">
              <View className="vd-flex">
                <img
                  src={ALL_AVATARS_IMG}
                  alt="avatars"
                  className="vd-h-24"
                />
              </View>
              <View className="vd-flex vd-gap-4 vd-h-28 vd-items-center">
                <Text
                  fontSize="caption"
                  weight="semibold"
                  color="text-brand-soft"
                  className="vd-tracking-[0.012rem]"
                >
                  3500+
                </Text>
                <Text
                  fontSize="caption"
                  weight="semibold"
                  color="text-neutral-secondary"
                  className="vd-tracking-[0.012rem]"
                >
                  Users connected with Expert
                </Text>
              </View>
            </View>
          </View>
          <ConnectWithAlumniButton
            name={name}
            setSidebarModalStage={setSidebarModalStage}
            onModalClose={onModalClose}
            userId={userId}
            context="vd-ds-btn"
          >
            {
              isTablet ? (
                <Button
                  buttonType="solid"
                  size="s"
                  title="Request an Expert Session"
                  variants="hero"
                  spaced
                  weight="semibold"
                  upperCase
                  className="vd-py-12"
                  onClick={() => {}}
                />
              ) : (
                <Button
                  buttonType="solid"
                  size="m"
                  title="Request an Expert Session"
                  variants="hero"
                  spaced
                  weight="semibold"
                  upperCase
                  className="vd-py-12"
                  onClick={() => {}}
                />
              )
            }
          </ConnectWithAlumniButton>
        </View>

        <View className="vd-bg-background-brand-subtlest
         vd-py-4 vd-justify-center vd-overflow-hidden"
        >
          <View className={classNames(
            styles.stripTransition,
            'vd-gap-x-4 vd-items-center',
          )}
          >
            <Icon
              color="icon-brand-soft"
              iconSize="xxs"
              name={acsBannerStripDataV2[stripStep].icon}
              type="fill"
            />
            <Text fontSize="caption" color="text-neutral-primary">
              {acsBannerStripDataV2[stripStep].text}
              <Text
                fontSize="caption"
                color="text-neutral-primary"
                weight="bold"
              >
                {acsBannerStripDataV2[stripStep].highlightedText}
              </Text>
            </Text>
          </View>
        </View>
      </View>
    ) : (
      <View className="vd-flex-col vd-bg-surface-neutral-base
        vd-border-solid vd-border-border-neutral-subtler vd-relative"
      >
        <img
          src={ACS_BANNER_BG}
          alt="banner-bg"
          className="vd-absolute"
          style={{ zIndex: '-1' }}
        />
        <View className="vd-absolute vd-right-none">
          <Label
            label="NEW"
            labelSize="xxs"
            labelVariant="brand"
          />
        </View>
        <View className="vd-flex-col vd-p-16">
          <View className="vd-flex-col vd-gap-8">
            <Text fontSize="b1" weight="bold" color="text-neutral-primary">
              Connect 1-1 with Alumni
            </Text>
            <Text fontSize="b3" color="text-neutral-tertiary">
              We will match you with the alumni based on their
              <br />
              availability and your career preferences
            </Text>
          </View>
          <hr className="sm:vd-my-12 vd-py-6" />
          <View className="vd-flex-row vd-items-center vd-gap-12">
            <View className="vd-flex">
              <img
                src={AVATAR_IMG_URL}
                alt="avatar 1"
                className="vd-w-24 vd-h-24 vd-form-radio"
              />
              <img
                src={AVATAR_IMG_URL}
                alt="avatar 2"
                className="vd-w-24 vd-h-24 vd-form-radio -vd-mx-8"
              />
              <View className="vd-w-24 vd-h-24 vd-form-radio
                vd-bg-surface-neutral-elevate-low
                vd-border-solid vd-border-border-neutral-subtle vd-p-2"
              >
                <img src={IMG_1000} alt="learners count" />
              </View>
            </View>
            <Text fontSize="caption" color="text-neutral-tertiary">
              Learners have connected with alumni
            </Text>
          </View>
          <ConnectWithAlumniButton
            name={name}
            setSidebarModalStage={setSidebarModalStage}
            onModalClose={onModalClose}
            userId={userId}
            context="vd-ds-btn"
          >
            <Button
              buttonType="solid"
              size="s"
              title="Request for 1-1 Alumni Session"
              variants="hero"
              spaced
              weight="semibold"
              upperCase
              className="vd-py-12 vd-mt-16"
              onClick={() => {}}
            />
          </ConnectWithAlumniButton>
        </View>
        <View className="vd-bg-background-brand-subtlest
          vd-px-12 vd-py-8 vd-justify-center vd-overflow-hidden"
        >
          <View className={classNames(
            styles.stripTransition,
            'vd-gap-x-4 vd-items-center',
          )}
          >
            <Icon
              color="icon-brand-soft"
              iconSize="xxs"
              name={acsBannerStripData[stripStep].icon}
              type="fill"
            />
            <Text fontSize="caption" color="text-neutral-primary">
              {acsBannerStripData[stripStep].text}
              <Text
                fontSize="caption"
                color="text-neutral-primary"
                weight="bold"
              >
                {acsBannerStripData[stripStep].highlightedText}
              </Text>
            </Text>
          </View>
        </View>
      </View>
    )
  );
};

export default AlumniConnectBoxRevamp;
